import useSWR from 'swr';

import { endpoints, fetcherGet } from 'src/lib/axios';

// ----------------------------------------------------------------------

interface MessageCounts {
  totalPending: number;
  totalApproved: number;
  totalRejected: number;
  totalBannedWords: number;
}

interface SidebarCountsData {
  pendingMedias: number;
  pendingPayments: number;
  pendingOrders: number;
  pendingJournalists: number;
  pendingEditorRequests: number;
  pendingPaymentEditorRequests: number;
  pendingNewsletterAdsRequests: number;
  pendingOutreach: number;
  pendingMediaProposals: number;
  pendingManagedServices: number;
  pendingKiwosanMedia: number;
  messages: MessageCounts;
}

const REFRESH_INTERVAL = 5 * 60 * 1000; // 5 minutos

export function useSidebarCounts() {
  const { data, isLoading, error, mutate } = useSWR<SidebarCountsData>(
    endpoints.dashboard.sidebarCounts,
    fetcherGet,
    {
      refreshInterval: REFRESH_INTERVAL,
      revalidateOnFocus: false,
    }
  );

  return {
    counts: data ?? null,
    loading: isLoading,
    error,
    refresh: mutate,
  };
}
